import {
    ROUTE_LIST_API_SUCCESS,
    ROUTE_LIST_API_FAIL,
    SET_ACTIVE_ROUTE,
} from "./actionTypes";

const INIT_STATE = {
    data: {},
    activeRoute: localStorage.getItem("activeRoute") || "",
};

const Route_List = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ROUTE_LIST_API_SUCCESS:
            return {
                ...state,
                data: action.payload.OK
            };

        case ROUTE_LIST_API_FAIL:
            return {
                ...state,
                apiDataError: action.payload.error
            };

        case SET_ACTIVE_ROUTE:
            localStorage.setItem("activeRoute", action.payload);
            return {
                ...state,
                activeRoute: action.payload
            }
        default:
            return state;
    }
}

export default Route_List;